import Error403 from '../components/Error/403'
import Error404 from '../components/Error/404'
import Error429 from '../components/Error/429'
import Error500 from '../components/Error/500'
import Error from '../components/Error/Index'

export default [
  {
    path: '/client/403',
    name: 'error403',
    component: Error403,
    meta: { location: ['Error: 403 Forbidden'] },
  },
  {
    path: '/client/404',
    name: 'error404',
    component: Error404,
    meta: { location: ['Error: 404 Not Found'] },
  },
  {
    path: '/client/429',
    name: 'error429',
    component: Error429,
    meta: { location: ['Error: 429 Too Many Request'] },
  },
  {
    path: '/client/500',
    name: 'error500',
    component: Error500,
    meta: { location: ['Error: 500 Internal Server Error'] },
  },
  {
    path: '/client/error',
    name: 'error',
    component: Error,
  },
]
